<template>
  <div class="filter-outer-blk">
    <div class="filter-search-blk">
      <v-text-field v-model="searchValue" :placeholder="placeHolder" dense hide-details @input="emitFilters"
        @click:clear="emitFilters" clearable> </v-text-field>
    </div>
    <!-- <div class="filter-blk" v-if="dateRange === false && filterData === 'toBeAssigned'">
   <v-menu v-model="dateModel" :nudge-right="40" :nudge-top="20" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
    <template v-slot:activator="{ on }">
     <v-text-field v-model="dateText" label="Select Date" readonly dense v-on="on" hide-details :disabled="checkDisableStatus()"> </v-text-field>
    </template>
<v-date-picker v-model="date" @change="emitFilters" color="black"></v-date-picker>
</v-menu>
</div> -->
    <div class="filter-blk" v-if="dateRange === true && ['toBeAssigned', 'trips'].includes(filterData) && tabType !== 'last-minute'">
      <v-menu  v-model="dateRangeModal" :nudge-right="40" :nudge-top="20" :close-on-content-click="false"
        transition="scale-transition" offset-y>
        <template v-slot:activator="{ on }">
          <v-text-field v-model="dateRangeText" label="Date Range" readonly dense v-on="on" hide-details>
          </v-text-field>
        </template>

        <v-date-picker v-if="$isIndigo==='true'"  v-model="dateRangeValue" range :max="today" color="black"></v-date-picker>
          <v-date-picker v-else  v-model="dateRangeValue" range :max="month" color="black"></v-date-picker>
    
      </v-menu>
     
    </div>

    <div class="filter-blk" v-if="[0, 1].includes(tripType)">
      <v-select v-model="serviceType" :items="serviceTypeItems" item-text="text" item-value="value"
        label="Responsibility Type" dense hide-details="auto" clearable></v-select>
    </div>
    <!-- <div class="date-filter-block" v-if="['toBeAssigned', 'trips'].includes(filterData)">
   <v-radio-group v-model="timeFilter" dense hide-details row color="#09009B" @change="updateTimeFilter">
    <v-radio label="7 Hours" value="7"></v-radio>
    <v-radio label="24 Hours" value="24"></v-radio>
   </v-radio-group>
  </div> -->
    <!-- <div class="filter-blk" v-if="filterData === 'toBeAssigned' || filterData === 'trips'">
   <v-autocomplete v-model="branchState" placeholder="State" label="State" dense outlined hide-details="auto" :items="filters" item-text="name" return-object clearable :disabled="searchValue !== ''">
   </v-autocomplete>
  </div> -->
    <!-- <div class="filter-blk" v-if="filterData === 'toBeAssigned' || filterData === 'trips'">
      <v-autocomplete
        v-model="branch"
        placeholder="Branch"
        label="Branch"
        dense
        outlined
        hide-details="auto"
        :items="branchState.branch"
        item-text="name"
        return-object
        clearable
        :disabled="searchValue !== ''">
      </v-autocomplete>
    </div> -->

    <div class="reset-button-blk" style="">
      <v-btn text color="#ff9500" @click="emitFilters"><i class="fas fa-redo"></i></v-btn>
      <v-btn color="#ff9500" @click="resetFilters" small>Reset</v-btn>
    </div>
    <div v-if="tripList && tripList.length > 0 && !type === 'tripsList'" class="m-left">
      <v-btn color="#eea004" @click="exportReport()"> download </v-btn>
    </div>
  </div>
</template>

<script>
import axios from "@/axios/axios-global";
import * as moment from "moment";
import XLSX from "xlsx";
import utils_json from "../../../assets/utils.json";
export default {
  name: "Filters",
  props: {
    dateRange: Boolean,
    placeHolder: String,
    filterData: String,
    tripList: Array,
    tripType: Number,
    type: String,
    tab: Number,
    tabType: String,
  },
  data: () => {
    return {
      filters: [],
      cityFilters: [],
      searchValue: "",
      state: "",
      city: "",
      branchState: "",
      branch: "",
      dateModel: false,
      date: "",
      dateRangeModal: false,
      dateRangeValue: [],
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      today: moment().add(2, "days").format("YYYY-MM-DD"),
      month: moment().endOf("month").format("YYYY-MM-DD"),
      utils_json: utils_json,
      status: -1,

      timeFilter: "7",
      serviceType: null,
      serviceTypeItems: [
        { text: "Pickup", value: 1 },
        { text: "DropOff", value: 2 },
      ],
    };
  },
  watch: {
    // searchValue() {
    //   if (this.searchValue === null) {
    //     this.searchValue = ''
    //   }
    //   this.emitFilters()
    // },
    tab() {
      this.resetFilters();
    },
    tripType() {
      this.branchState = "";
      this.branch = "";
      this.searchValue = "";
      this.date = "";
      this.timeFilter = "7";
      this.dateRangeValue = [];
      this.startDate = moment().format("YYYY-MM-DD");
      this.endDate = moment().format("YYYY-MM-DD");
      this.serviceType = null;
    },
    state() {
      if (this.state === null) {
        this.state = "";
        this.city = "";
      }
      this.emitFilters();
    },
    city() {
      if (this.city === null) {
        this.city = "";
      }
      this.emitFilters();
    },
    branchState() {
      if (this.branchState === null) {
        this.branchState = "";
        this.branch = "";
      }
      this.emitFilters();
    },
    branch() {
      if (this.branch === null) {
        this.branch = "";
      }
      this.emitFilters();
    },
    serviceType() {
      this.emitFilters();
    },
    dateRangeValue() {
      if (this.dateRangeValue[0]) {
        if (this.dateRangeValue[1]) {
          if (this.dateRangeValue[0] > this.dateRangeValue[1]) {
            this.startDate = moment(this.dateRangeValue[1]).format("YYYY-MM-DD");
            this.endDate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
          } else {
            this.startDate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
            this.endDate = moment(this.dateRangeValue[1]).format("YYYY-MM-DD");
          }
          this.emitFilters();
          this.dateRangeModal = false;
        }
        this.timeFilter = "";
      }
    },
  },
  async mounted() {
    await this.getBranchFilter();
  },
  methods: {
    // async getFilters() {
    //   const response = await axios.get('/router/filterData')
    //   this.cityFilters = response.data
    // },
    updateTimeFilter() {
      if (this.timeFilter !== "") {
        this.startDate = moment().format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
        this.dateRangeValue = [];
      }
      this.emitFilters();
    },
    async getBranchFilter() {
      const response = await axios.get("trip/branchesByState");
      this.filters = response.data;
    },
    handleClear() {
      this.searchValue = "";
      this.emitFilters();
    },
    resetFilters() {
      this.branchState = "";
      this.branch = "";
      this.searchValue = "";
      this.date = "";
      this.timeFilter = "7";
      this.dateRangeValue = [];
      this.startDate = moment().format("YYYY-MM-DD");
      this.endDate = moment().format("YYYY-MM-DD");
      this.status = -1;
      this.serviceType = null;
      this.emitFilters();
    },
    emitFilters() {
      this.dateModel = false;
      if (this.searchValue && this.searchValue.length > 0 && this.searchValue.length < 3) {
        return;
      }

      let payload = {
        start: ["toBeAssigned", "trips"].includes(this.filterData) ? this.startDate : undefined,
        end: ["toBeAssigned", "trips"].includes(this.filterData) ? this.endDate : undefined,
        // date: this.filterData === "toBeAssigned" && this.searchValue === "" ? this.date : undefined,
        state: this.branchState !== "" && this.searchValue === "" ? this.branchState.id : undefined,
        searchValue: this.searchValue,
        branch: this.branch !== "" && this.searchValue === "" ? this.branch.id : undefined,
        time: this.timeFilter,
        status: this.dateRangeValue.length > 0 ? undefined : -1,
        serviceType:
          ["toBeAssigned", "trips"].includes(this.filterData) && [0, 1].includes(this.tripType) && this.serviceType != null
            ? this.serviceType
            : undefined,
        // city: this.city !== '' ? this.city.id : undefined
      };
      this.$emit("get-filter", payload);
    },
    exportReport() {
      const headerRow = this.utils_json.headers.to_be_assigned.map((header) => header.text);
      const excelData = [
        headerRow,
        ...this.tripList.map((item) => {
          return headerRow.map((headerKey) => {
            const headerConfig = this.utils_json.headers.to_be_assigned.find((header) => header.text === headerKey);
            const key = headerConfig.value;
            if (key.includes(".")) {
              const keys = key.split(".");
              const mainKey = keys[0];
              const subKey = keys[1];
              if (mainKey === "pickUpTime" && item[mainKey]) {
                return item[mainKey][subKey] ? moment(item[mainKey][subKey]).format("YYYY-MM-DD HH:mm:ss") : "";
              }
              return item[mainKey] && item[mainKey][subKey] ? item[mainKey][subKey] : "";
            }
            if (key === "pickUpTime") {
              return item[key] ? moment(item[key]).format("YYYY-MM-DD HH:mm:ss") : "";
            }
            return item[key] ? item[key] : "";
          });
        }),
      ];
      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `Trips.xlsx`);
    },
    checkDisableStatus() {
      return this.searchValue ? true : false;
    },
  },
  computed: {
    dateText() {
      if (this.date !== "") {
        return moment(this.date).format("LL");
      } else {
        return "";
      }
    },
    dateRangeText() {
      let start = "";
      let end = "";
      if (this.dateRangeValue.length > 0) {
        if (this.dateRangeValue[0] > this.dateRangeValue[1]) {
          start = moment(this.dateRangeValue[1]).format("MMM DD");
          end = moment(this.dateRangeValue[0]).format("MMM DD");
        } else {
          start = moment(this.dateRangeValue[0]).format("MMM DD");
          end = moment(this.dateRangeValue[1]).format("MMM DD");
        }
        return `${start} ~ ${end}`;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filter-outer-blk {
  display: flex;
  align-items: center;
  width: 100%;

  .filter-search-blk {
    width: 20%;
  }

  .filter-blk {
    width: 15%;
    margin-left: 10px;
  }

  .date-filter-block {
    margin-left: 10px;
  }

  .reset-button-blk {
    margin: 0px 10px;
    display: flex;
    gap: 10px;
    align-items: center;
  }
}

::v-deep .v-text-field {
  font-size: 13px;
}

::v-deep .v-label {
  font-size: 13px !important;
}

.v-list {
  padding: 3px 0;
}

.m-left {
  margin-left: 10px;
}

.v-input--selection-controls {
  margin-top: 10px;
  padding: 0 10px;
}
</style>
